export default "__VITE_ASSET__CEUy0l8l__"